import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import { DirectUpload } from '@rails/activestorage';
import PostUploadsBlock from "./PostUploadsBlock/PostUploadsBlock";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import Modal from "../Helpers/Modal/Modal";
import UnsavedModal from "../Helpers/Modal/UnsavedModal";
import Dropzone from "./Dropzone";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
import { async } from "q";
import TemplateDropdown from "../Templates/TemplateDropdown";
import TemplateVariableCard from "../Templates/TemplateVariableCard";
import { set } from "lodash";
import {
  useTitleVariable,
  getOwnerType,
  getBeneficiaryFields,
  getDonorFields,
  detectTemplateVariables,
  detectTitleVariables,
  useVariable
} from "../Helpers/Functions/Templates";
import PostFormInfoModal from "../Helpers/Modal/InfoModals/PostFormInfoModal";
import SummaryModal from "../Helpers/Modal/Posts/SummaryModal";

export default function PostsForm(props) {

  const [post, setPost] = useState(props.post);
  const [saving, setSaving] = useState(false);
  const [isDirty, setDirty] = useState(false);
  const [isNotSaved, setNotSaved] = useState(false);
  const [cancelRoute, setCancelRoute] = useState(`/users/${post.user_id}/posts/`)
  const [saved, setSaved] = useState(false);
  const [showNewPostModal, setShowNewPostModal] = useState(false);

  // Post As
  const [selectedPostAs, setSelectedPostAs] = useState(null);
  const [postAsOptions, setpostAsOptions] = useState(null)

  // Audience
  const [audienceOptions, setAudienceOptions ] = useState(props.availableAudiences)
  const [fullAudienceOptions, setFullAudienceOptions] = useState(props.availableAudiences)
  const _usingAudience = post.audience_members && post.audience_members.length > 0;
  const hasPotentialAudience = post.post_type && post.post_type == 'project' ? 
  audienceOptions.filter(o => o.type == 'project') && audienceOptions.filter(o => o.type == 'project').length > 0 :
  audienceOptions.filter(o => o.type == 'user') && audienceOptions.filter(o => !o.type || o.type == 'user').length > 1

  const [usingAudience, setUsingAudience] = useState(_usingAudience);

  // File Upload
  let orderedUploads = []
  if (post && post.ordered_uploads) {
    orderedUploads = props.post.ordered_uploads;
  }
  const [files, setFiles] = useState(orderedUploads);
  const inputFiles = useRef(null);
  const [fileUploading, setFileUploading] = useState(false);
  const backendForDnD = "ontouchstart" in window ? TouchBackend : HTML5Backend;
  const [senderVariable, setSenderVariable] = useState([])
  const [receiverVariable, setReceiverVariable] = useState([])
  const [donorFields, setDonorFields] = useState([])
  const [beneficiaryFields, setBeneficiaryFields] = useState([])
  const [organizationVariable, setOrganizationVariable] = useState(['name'])
  const [totalVariables, setTotalVariables] = useState([])
  const [postOwnerType, setPostOwnerType] = useState('')
  const [templates, setTemplates] = useState(props.templates)
  const [showTemplateTitle, setShowTemplateTitle] = useState(false)
  const [showTemplateContent, setShowTemplateContent] = useState(false)
  const [templateVariable, setTemplateVariable] = useState(false)
  const [titleVariable, setTitleVariable] = useState(false)
  const [count, setCount] = useState(0)
  const [lastIndex, setLastIndex] = useState(-1)
  const [saveTemplate, setSaveTemplate] = useState(false)
  const [changeToggleLabel, setChangeLabel] = useState(false)
  const [showPostSummary, setShowPostSummary] = useState(false)
  const [postSummary, setPostSummary] = useState({sender: '', receiver: ''})
  const [showApproveButton, setShowApproveButton] = useState(true)
  const [template, setTemplate] = useState({
    title: post.title,
    content: post.content
  })
  const postContent = useRef(null)
  const usingApprovals = window.clarity.ct.ua;
  const current_user = props.current_user
  const fileFormats = [
    'image/*',
    'video/*',
    '.doc',
    '.docx',
    '.pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ].join();
  const users = props.users
  const [actualPostOwner, setActualPostOwner] = useState(post.user_id)

  const allowManagerPosts = _.some(props.currentTeam.feature_flags, (a) => a === 'manager_profile_and_posts');
  const isManager = (props.currentUser.user_type === 'manager' || props.currentUser.user_type === 'assistant_manager');
  const inManagerPostView = (props.currentUser.user_type === 'manager' || props.currentUser.user_type === 'assistant_manager') && props.post.user_id === props.currentUser.id;

  useEffect(() => {
    // run use template on condition
    if (!isDirty) useTemplate();
    detectTitleVariables(post, setTitleVariable)
    detectTemplateVariables(post, setTemplateVariable)
    getOwnerType(post, setPostOwnerType, users)
    clearVariables()
    arrangeVariables()
    setTemplate({...template, title: post.title, content: post.content})

  }, [post])

  useEffect(() => {
    setActualPostOwner(selectedPostAs && selectedPostAs.id ? selectedPostAs.id : post.user_id)
  }, [selectedPostAs])

  useEffect(() => {
    if (post.audience_members && post.post_type == 'project' && post.audience_members.length > 0 && post.id) {
      if (post.audience_members[0].public_disabled) setPost({...post, public_project_audience: false})
    }
  }, [])

  useEffect(() => {decideApproveButtonDisplay()}, [selectedPostAs])

  const useTemplate = () => {
    const queryParams = new URLSearchParams(window.location.search)
    const encodedTemplate = queryParams.get('template')
    const queryTemplate = JSON.parse(decodeURIComponent(encodedTemplate))

    if (queryTemplate) {
    setPost({...post, title: queryTemplate.title, content: queryTemplate.content})
    setTemplate({...template, title: queryTemplate.title, content: queryTemplate.content})
    setDirty(true)
    setChangeLabel(true)
  }
  }

  const clearVariables = () => {
    setDonorFields([])
    setBeneficiaryFields([])
    setReceiverVariable([])
    setSenderVariable([])
    setTotalVariables([])
  }

  // method for displaying the right sender for the user types
  const arrangeVariables = () => {
    getDonorFields(users, donorFields)
    getBeneficiaryFields(users, beneficiaryFields)

    // if user type is donor
    if (postOwnerType == "donor") {
      setSenderVariable(donorFields)
      setReceiverVariable(beneficiaryFields)
    } else if (postOwnerType == "beneficiary") {
      setSenderVariable(beneficiaryFields)
      setReceiverVariable(donorFields)
    } else if (postOwnerType == "manager") {
      setTotalVariables([...donorFields, ...beneficiaryFields])
      setReceiverVariable([...new Set(totalVariables)])
      setSenderVariable(['first_name', 'last_name', 'email', 'username', 'birthday', 'bio'])
    } else if (post.project_id) {
      setTotalVariables([...donorFields, ...beneficiaryFields])
      setReceiverVariable([...new Set(totalVariables)])
      setSenderVariable(['name', 'manager_name', 'manager_email', 'coordinator_name', 'coordinator_email'])
    } else {
      setTotalVariables([...donorFields, ...beneficiaryFields])
      setReceiverVariable([...new Set(totalVariables)])
      setSenderVariable(['first_name', 'last_name', 'email', 'username'])
    }
  }


  window.onbeforeunload = (event) => {
    if (isDirty) {
         return ""
    }
  }

  useEffect(() => {
    if(allowManagerPosts && inManagerPostView && !post.id){
      initializePostAsOptions()
    }
  }, []);

  useEffect(() => {
    if(selectedPostAs && !post.id) {
      setPost({ ...post, user_id: selectedPostAs.id })
      const fetchData = async () => {
        const data = await initializeAudienceOptions(selectedPostAs);
        setAudienceOptions(data.data.users)
        setFullAudienceOptions(data.data.users)
        setUsingAudience(false)
        setPost(post => {
          setDirty(false)
          return { ...post, audience_members: '' }
        });
      }

      fetchData().catch(console.error);
    }
  }, [selectedPostAs]);

  const initializePostAsOptions = () => {
    let updatedOptions = _.concat(props.allBeneficiaries, props.allDonors)
    updatedOptions = _.orderBy(updatedOptions, ['first_name', 'asc'], ['last_name'], ['asc'])
    updatedOptions = _.concat(props.currentUser, updatedOptions)
    setpostAsOptions(updatedOptions)
    setSelectedPostAs(props.currentUser)
  }

  const initializeAudienceOptions = async (user) => {
    let userId = user && user.id ? user.id : post.user_id
    return HTTP.get(`/users/${userId}/get_audience.json`)
  }

  const handleSave = async () => {
    if (!post.title || post.title.length < 1) {
      Alert.show('notice', 'Title is required for a post')
      return
    }

    if (post.post_type == 'project' && (!post.audience_members || post.audience_members.length !== 1)) {
      Alert.show('notice', `You must select one audience for a ${props.currentTeam.project_title.toLowerCase()} post`)
      return
    }

    if (saveTemplate) await saveAsTemplate(post)
    setSaving(true)
    setDirty(false)

    let data = { post: post }
    data.post.ordered_file_ids = []
    data.post.ordered_file_ids = files.map((file)=>file.blob_id || file.id)
    data.post.files =  files

    if (post.id) {
      try {
        await updatePost(data);
        setSaved(false)
      } catch {
        Alert.show("error", "Could not save. Try again or refresh.")
        setSaving(false);
        return;
      }

      Alert.show("notice", "Post saved!");
      setSaving(false);

      setTimeout(() => {
        redirectAfterEdit(document.referrer);
      }, 1000)
    } else {
      try {
        await saveNewPost(data);
        setSaved(true)
      } catch {
        Alert.show("error", "Could not save. Try again or refresh.")
        setSaving(false);
        return;
      }

      Alert.show("notice", "Post saved!");
      setSaving(false);

      setTimeout(() => {
        setShowNewPostModal(true)
      }, 1000)
    }
  }

  const handleSaveAndApprove = async () => {
    if (!post.title || post.title.length < 1) {
      Alert.show('notice', 'Title is required for a post')
      return
    }

    if (post.post_type == 'project' && (!post.audience_members || post.audience_members.length !== 1)) {
      Alert.show('notice', `You must select one audience for a ${props.currentTeam.project_title.toLowerCase()} post`)
      return
    }

    if (saveTemplate) await saveAsTemplate(post)
    setSaving(true)
    setDirty(false)

    let data = { post: post }
    data.post.ordered_file_ids = []
    data.post.ordered_file_ids = files.map((file)=>file.blob_id || file.id)
    data.post.files =  files
    let postId = post.id;

    if (post.id) {
      try {
        await updatePost(data);
      } catch {
        Alert.show("error", "Could not save. Try again or refresh.")
        setSaving(false);
        return;
      }

      try {
        await approvePost(postId);
      } catch {
        Alert.show("error", "Could not approve. Try again or refresh.")
        setSaving(false);
        return;
      }

      Alert.show("notice", "Post saved and approved!");
      setSaving(false);

      setTimeout(() => {
        redirectAfterEdit(document.referrer);
      }, 1000)

    } else {
      try {
        let response = await saveNewPost(data);
        postId = response.data.id;
      } catch {
        Alert.show("error", "Could not save. Try again or refresh.")
        setSaving(false);
        return;
      }

      try {
        await approvePost(postId);
      } catch {
        Alert.show("error", "Could not approve. Try again or refresh.")
        setSaving(false);
        return;
      }

      Alert.show("notice", "Post saved and approved!");
      setSaving(false);

      setTimeout(() => {
        setShowNewPostModal(true)
      }, 1000)
    }
  }

  const approvePost = async (postId) => {
    return HTTP.patch(`/users/${post.user_id}/posts/${postId}/approve`, {
      approved: 'approve',
      project_id: post.project_id
    })
  }

  const saveNewPost = async (data) => {
    return HTTP.post(`/users/${post.user_id}/posts.json`, data)
  }

  const updatePost = async (data) => {
    return HTTP.patch(`/users/${post.user_id}/posts/${post.id}.json`, data)
  }

  const redirectAfterEdit = async (previousURL) => {
    let path = previousURL.includes("/dashboard") ? `/dashboard` : `/users/${post.user_id}/posts`;
    if (post.user_id == null) {
      window.location.replace(`/projects/${post.project_id}/posts`);
      return
    }
    window.location.replace(path);
  }

  const redirectDeclineNewPost = async () => {
    let path = allowManagerPosts && inManagerPostView ? `/dashboard` : `/users/${post.user_id}/posts`;
    if (post.user_id == null) {
      window.location.replace(`/projects/${post.project_id}/posts`);
      return
    }
    window.location.replace(path);
  }

  const redirectToNewPost = async () => {
    let userId = allowManagerPosts && inManagerPostView ? props.currentUser.id : post.user_id;
    if (post.user_id == null) {
      window.location.replace(`/projects/${post.project_id}/posts/new`);
      return
    }
    window.location.replace(`/users/${userId}/posts/new`);
  }

  const moveFile = (dragIndex, hoverIndex) => {
    const draggedFile = files[dragIndex];
    setFiles(
      update(files, {
        $splice: [[dragIndex, 1], [hoverIndex, 0, draggedFile]]
      })
    );
  };

  const onDrop = (acceptedfiles) => {
    Array.from(acceptedfiles).forEach(file => uploadFile(file))
  }

  const onFilesChange = (files) => {
    Array.from(files).forEach(file => uploadFile(file))
  }

  const uploadFile = (file) => {
    // Check for .jiff extension
    if (file.name.endsWith('.jfif')) {
      Alert.show('error', '.jiff image is not allowed');
      return;
    }

    setFileUploading(true)
    const upload = new DirectUpload(file, '/api/v1/direct_uploads');
    upload.create((error, blob) => {
      if (error) {
        // Handle the error
        Alert.show("error", "Could not update. Try again.");
        setFileUploading(false)
      } else {
        setTimeout(() => { setFileUploading(false) }, 5000);
        setFiles(prevArray => [...prevArray, blob])
      }
    })
  }

  const removeFile = (file) => {
    HTTP.delete(`/users/${post.user_id}/posts/${post.id}/delete_file_attachment.json?file_id=${file.signed_id}`)
      .then(response => {
        Alert.show("notice", "File removed!");

        let filesClone = [...files]; // make a separate copy of the array
        _.remove(filesClone, { signed_id: file.signed_id })
        setFiles(filesClone);
    }).catch(e => {
      Alert.show("error", "Could not remove. Try again or refresh.");
    })
  }

  const cancelFunction = () => {
    if (isDirty) {
      setNotSaved(true)
      setCancelRoute("#")
    } else {
      setNotSaved(false)
      setCancelRoute(`/users/${post.user_id}/posts/`)
    }
  }

  const proceed = () => {
    setNotSaved(false)
    window.location = `/users/${post.user_id}/posts/`
  }

  const cancel = () => {
    setNotSaved(false)
  }

  const saveAsTemplate = (data) => {
    return HTTP.post(`/templates/create/${0}.json`, data)
  }

  const fillTemplate = (data) => {
    setPost({...post, title: data.title, content: data.content})
    setTemplate({...template, title: data.title, content: data.content})
    setChangeLabel(true)
  }

  const prepareDataForSummary = (actionType) => {
    let sender = ''
    let receiver = ''
    let presentAudience = false

    if (selectedPostAs) {
      presentAudience = post.audience_members && post.audience_members.length > 0
      sender = selectedPostAs.last_name ? `${selectedPostAs.first_name} ${selectedPostAs.last_name}` : selectedPostAs.first_name
      receiver = presentAudience ? post.audience_members.map((audience) => audience.name).join(', ') : 'All your connections'
      if ((selectedPostAs.user_type == 'manager' || selectedPostAs.user_type == 'assistant_manager') && !presentAudience) {
        receiver = `All of your ${(props.currentTeam.donor_title + ', ' + props.currentTeam.beneficiary_title).toLowerCase()} and users`
      }
      setPostSummary({sender: sender, receiver: receiver, action: actionType})
      setShowPostSummary(true)
      return
    }

    if (post.user_id && !post.id) {
      presentAudience = post.audience_members && post.audience_members.length > 0
      sender = post.user.last_name ? `${post.user.first_name} ${post.user.last_name}` : post.user.first_name
      receiver = presentAudience ? post.audience_members.map((audience) => audience.name).join(', ') : 'All your connections'
      if ((post.user.user_type == 'manager' || post.user.user_type == 'assistant_manager') && !presentAudience) {
        receiver = `All of your ${(props.currentTeam.donor_title + ', ' + props.currentTeam.beneficiary_title).toLowerCase()} and users`
      }
      setPostSummary({sender: sender, receiver: receiver, action: actionType})
      setShowPostSummary(true)
      return
    }
    
    if (post.user_id && post.id) {
      presentAudience = post.audience_members && post.audience_members.length > 0
      sender = post.user.user_info.last_name ? `${post.user.user_info.first_name} ${post.user.user_info.last_name}` : post.user.user_info.first_name
      receiver = presentAudience ? post.audience_members.map((audience) => audience.name).join(', ') : 'All your connections'
      if ((post.user.user_type == 'manager' || post.user.user_type == 'assistant_manager') && !presentAudience) {
        receiver = `All of your ${(props.currentTeam.donor_title + ', ' + props.currentTeam.beneficiary_title).toLowerCase()} and users`
      }
      setPostSummary({sender: sender, receiver: receiver, action: actionType})
      setShowPostSummary(true)
      return
    }

    if (post.project_id) {
      presentAudience = post.audience_members && post.audience_members.length > 0
      sender = post.project.name
      receiver = presentAudience ? post.audience_members.map((audience) => audience.name).join(', ') : 'All your connections'
      setPostSummary({sender: sender, receiver: receiver, action: actionType})
      setShowPostSummary(true)
      return
    }
  }

  const decideApproveButtonDisplay = () => {
    // Edit existing post scenario
    if (post.id && post.user_id && post.user && (post.user.user_type == 'manager' || post.user.user_type == 'assistant_manager')) {
      setShowApproveButton(false)
      return
    }

    // New post from admin post view 
    if (!post.id && selectedPostAs && (selectedPostAs.user_type == 'manager' || selectedPostAs.user_type == 'assistant_manager')) {
      setShowApproveButton(false)
      return
    }

    // New post from other users post view
    if (!post.id && !selectedPostAs && post.user_id && post.user && (post.user.user_type == 'manager' || post.user.user_type == 'assistant_manager')) {
      setShowApproveButton(false)
      return
    }

    setShowApproveButton(true)
  }

  return (
    <React.Fragment>
      <div className="card">
        <div className="card-header flex-header">
          <h4 className="card-title">
            { post.title || 'New Post'}
          </h4>

          <div>
            {post.user_id !== null && <a href={cancelRoute} className="btn btn-outline-danger mr-1" onClick={cancelFunction}>
              Cancel
            </a>}
            {post.user_id == null && <a href={`/projects/${post.project_id}/posts`} className="btn btn-outline-danger mr-1" onClick={cancelFunction}>
              Cancel
            </a>}

            <div className="btn-group">
              <button onClick={() => prepareDataForSummary('save')}
                disabled={fileUploading}
                name="button"
                className={`btn btn-primary ${usingApprovals && isManager? "btn-split-left" : ""}`}
                type="button">
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                Save
              </button>
              {usingApprovals && isManager && showApproveButton &&
                <>
                  <button type="button" className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right" data-toggle="dropdown" aria-expanded="false">
                    <span className="sr-only">Toggle Dropdown</span>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-right">
                    <li>
                      <button onClick={() => prepareDataForSummary('save-and-approve')}
                        disabled={fileUploading}
                        name="button"
                        className="dropdown-item"
                        type="button">
                          Save and Approve
                      </button>
                    </li>
                  </ul>
                </>
              }
            </div>
          </div>
        </div>
        <div className="card-body">
          {(current_user.user_type == 'manager' || current_user.user_type == 'assistant_manager' || current_user.user_type == 'project_manager'
          || current_user.user_type == 'project_coordinator' || current_user.user_type == 'sponsorship_manager') &&
            <div>
              <div className="row align-center">
                <div className="col-md-6 align-center">
                  <div className="form-group">
                      <ToggleSwitch
                        small
                        id="template_toggle"
                        checked={saveTemplate}
                        onChange={checked => {
                          setSaveTemplate(checked)
                        }}
                      />
                      {!changeToggleLabel &&
                        <label htmlFor="template_toggle">Save this post as template</label>
                      }
                      {changeToggleLabel &&
                        <label htmlFor="template_toggle">Save as a new template</label>
                      }
                  </div>
                </div>

                <div className="col-md-6 align-center">
                <div className="form-group">
                  <PostFormInfoModal />
                </div>
                </div>
              </div>

              {((post.user_id && selectedPostAs && selectedPostAs.user_type == 'donor') || (!selectedPostAs && post.user && post.user_id && post.user.user_type == 'donor')) &&
                <div className="row align-center">
                  <div className="col-md-6 align-center">
                    <div className="form-group">
                        <ToggleSwitch
                          small
                          id="post_type"
                          checked={post.post_type && post.post_type == 'project' ? true : false}
                          onChange={checked => {
                            let type = checked ? 'project' : 'user'
                            setPost(post => {
                              return { ...post, post_type: type, audience_members: [] }
                            });
                            setUsingAudience(false)
                          }}
                        />
                        {post.post_type && post.post_type == 'project' &&
                          <label htmlFor="post_type">{props.currentTeam.project_title} post</label>
                        }
                        {(!post.post_type || post.post_type !== 'project') &&
                          <label htmlFor="post_type">{props.currentTeam.donor_title} post</label>
                        }
                    </div>
                  </div>

                  <div className="col-md-6 align-center">
                  </div>
                </div>
              }
            </div>
          }
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="title">Title</label>
                <input className="form-control" placeholder="New Post" type="text" name="title" id="title"
                  value={post.title}
                  onChange={e => {
                    const val = e.target.value;
                    setPost(post => {
                      return { ...post, title: val }
                    });
                    setDirty(true)
                    setShowTemplateTitle(true)
                  }}
                  onBlur={() => setTimeout(() => setShowTemplateTitle(false), 400)}
                />

                {titleVariable && (current_user.user_type == "manager" || current_user.user_type == 'assistant_manager' ||
                current_user.user_type == "project_manager" || current_user.user_type == 'project_coordinator') &&
                  <TemplateVariableCard post={template} current_user={current_user} senderVariables={senderVariable}
                  receiverVariables={receiverVariable} organizationVariable={organizationVariable}
                  useVariable={(value) => useTitleVariable(value, post, setPost, setTitleVariable)} realign={true}
                  />
                }

              {isDirty && showTemplateTitle && post.title.length > 0 &&
              <div className="template-class-cu">
                <TemplateDropdown data={
                  templates.filter(template => String(template.title).toLowerCase().includes(post.title.toLowerCase()))
                }
                fillTemplate={(value) => fillTemplate(value)}
                />

              {isDirty && showTemplateTitle &&
              <div className="template-class-cu">
                <TemplateDropdown data={
                  templates.filter(template => String(template.title).toLowerCase().includes(post.title.toLowerCase()))
                }
                fillTemplate={(value) => fillTemplate(value)}
                />
              </div>
              }
              </div>
              }
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="published_on">Published on</label>
                <Flatpickr className="form-control"
                  value={post.published_at}
                  onChange={(date, dateStr) => {
                    setPost(post => {
                      setDirty(true)
                      return { ...post, published_at: dateStr }
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-md-6">
              {allowManagerPosts && inManagerPostView && !post.id && (
              <div className="form-group" role="group" aria-labelledby="postAsLabel">
                <label id="postAsLabel">Post as</label>
                <div className="input-group">
                  <Select
                    className="w-100"
                    onChange={(person) => {
                      setDirty(true)
                      setSelectedPostAs(person)
                      if (person.user_type !== 'donor') {
                        setPost({...post, post_type: 'user', public_project_audience: false})
                      }
                    }}
                    options={postAsOptions}
                    getOptionLabel={(person) =>
                      `${person.first_name} ${person.last_name}`
                    }
                    getOptionValue={(person) => person.id}
                    value={selectedPostAs}
                  />
                </div>
              </div>
              )}

              <div className="form-group">
                <label htmlFor="audience">Who can see this post?</label>

                {!usingAudience && (<div>
                  <span>Visible to all your connections within Clarity. </span>
                  {hasPotentialAudience && <span><u><span className="text-primary cursor-pointer" onClick={() => setUsingAudience(true) }>Change audience</span></u>.</span>}
                </div>)}

                {usingAudience && (
                  <>
                    {(!post.post_type || post.post_type == 'user') &&
                      <>
                        <div className="input-group">
                          <Select
                            className="w-100 select-audience"
                            classNamePrefix="select-audience"
                            isMulti
                            value={post.audience_members}
                            onChange={(value) => {
                              setPost(post => {
                                setDirty(true)
                                return { ...post, audience_members: value }
                              });
                            }}
                            options={
                              post.post_type == 'project' ?
                              audienceOptions.filter(option => option.type && option.type == 'project') :
                              audienceOptions.filter(option => !option.type || option.type == 'user')
                            }
                            getOptionLabel={audience => `${audience.name}`}
                            getOptionValue={audience => audience.id }
                          />
                        </div>
                        <div className="description">
                          Leave empty for all your connections within Clarity to see this post.
                        </div>
                      </>
                    }

                    {post.post_type && post.post_type == 'project' &&
                      <>
                        <div className="input-group">
                          <Select
                            className="w-100 select-audience"
                            classNamePrefix="select-audience"
                            value={post.audience_members[0]}
                            onChange={(value) => {
                              setPost(post => {
                                setDirty(true)
                                return { ...post, audience_members: [value], public_project_audience: false }
                              });
                            }}
                            options={
                              post.post_type == 'project' ?
                              audienceOptions.filter(option => option.type && option.type == 'project') :
                              audienceOptions.filter(option => !option.type || option.type == 'user')
                            }
                            getOptionLabel={audience => `${audience.name}`}
                            getOptionValue={audience => audience.id }
                          />
                        </div>
                        <div className="description">
                          You can only choose one {props.currentTeam.project_title.toLowerCase()} per post and it is required
                        </div>
                      </>
                    }
                  </>
                )}
              </div>

              {post.user_id && post.post_type == 'project' && post.audience_members && post.audience_members.length > 0 && !post.audience_members[0].public_disabled && 
                (!post.audience_members[0].blocked_sponsors || post.audience_members[0].blocked_sponsors.length < 1 || 
                !post.audience_members[0].blocked_sponsors.includes(actualPostOwner)) &&
                <div className="align-center">
                  <div className="form-group">
                    <ToggleSwitch
                      small
                      id="public_project_audience_toggle"
                      checked={post.public_project_audience}
                      onChange={checked => {
                        setPost({...post, public_project_audience: checked})
                      }}
                    />
                    <label htmlFor="public_project_audience_toggle">
                      {post.public_project_audience &&
                        <>
                          Public post (<small>visible to {props.currentTeam.project_title.toLowerCase()} admins and sponsors </small>)
                        </>
                      }
                      {!post.public_project_audience &&
                        <>
                          Private post (<small>visible only to {props.currentTeam.project_title.toLowerCase()} admins</small>)
                        </>
                      }
                    </label>
                  </div>
                </div>
              }
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="body">Content</label>
                <textarea className="form-control textarea-resizable" name="content" id="content" ref={postContent}
                  value={post.content}
                  rows={15}
                  onChange={e => {
                    const val = e.target.value;
                    setPost(post => {
                      setDirty(true)
                      return { ...post, content: val }
                    });
                    setShowTemplateContent(true)
                  }}
                  onBlur={() => setTimeout(() => {
                    setShowTemplateContent(false)
                  }, 400)}
                ></textarea>

                {templateVariable && (current_user.user_type == "manager" || current_user.user_type == 'assistant_manager' ||
                current_user.user_type == "project_manager" || current_user.user_type == 'project_coordinator') &&
                  <TemplateVariableCard post={post} current_user={current_user} senderVariables={senderVariable}
                  receiverVariables={receiverVariable} organizationVariable={organizationVariable}
                  useVariable={(value) => useVariable(value, post, setPost, setTemplateVariable)} realign={false} />
                }

              {isDirty && showTemplateContent && post.content.length > 1 &&
              <div className="template-class-cu">
                <TemplateDropdown data={
                  templates.filter(template => String(template.content).toLowerCase().includes(post.content.toLowerCase()))
                }
                fillTemplate={(value) => fillTemplate(value)}
                />
              </div>
              }
              </div>
            </div>
          </div>
        </div>
      </div>

                  {/* Modals and Helpers */}
      {isNotSaved && <UnsavedModal message="You have not saved your post, are you sure you want to navigate away?" boldMessage="Click proceed to continue or cancel to remain on this page" proceed={proceed} cancel={cancel}/>}

      {showNewPostModal &&
        <Modal primaryButtonLabel="Yes" primaryButtonOnClick={redirectToNewPost} secondaryButtonLabel="No" secondaryButtonOnClick={redirectDeclineNewPost}>
          <div>Would you like to add another post?</div>
        </Modal>
      }

      {showPostSummary && 
        <SummaryModal
          data = {postSummary}
          handleClose ={ () => {
            setShowPostSummary(false);
            setPostSummary({sender: '', receiver: ''});
          }}
          handleProceed={() => {
            postSummary.action == 'save' ? handleSave() : handleSaveAndApprove();
            setShowPostSummary(false);
            setPostSummary({sender: '', receiver: ''});
          }}
          saving={saving}
        />
      }

                {/* End of modals and helpers */}

      <div className="card">
        <div className="card-header flex-header">
          <div>
            <h4 className="card-title">
              Files <small>(images / documents)</small>
            </h4>
            <p>Supported formats: .jpg/jpeg, .png, .pdf, .doc, .docx, .mp4 </p>
            <p>Files can be rearranged by clicking and dragging the file into the order you prefer.</p>
          </div>
          <div>

            <input ref={inputFiles} id="uploader" type="file" multiple accept={fileFormats}
              onChange={e => {
                return onFilesChange(e.currentTarget.files)}}
              direct_upload="true"
              className="d-none"
            />

            <button onClick={() => inputFiles.current.click()} name="button" className="btn btn-primary">
              {fileUploading && (<span><i className="fa fa-spinner-third fa-spin mr-2"></i> Uploading</span>)}
              {!fileUploading && (<span><i className="fa fa-plus mr-2"></i> Upload</span>)}
            </button>

          </div>
        </div>

        <div className="card-body">
          {files.length == 0 && (
            <>
            <p>No files uploaded yet</p>
            <Dropzone accept={fileFormats} onDrop={onDrop} />
            </>
          )}
          <DndProvider backend={backendForDnD}>
            <PostUploadsBlock isDraggable={true} fileFormats={fileFormats} uploads={files} moveFile={moveFile} removeFile={removeFile} />
          </DndProvider>
        </div>
      </div>
    </React.Fragment>
  );
}

PostsForm.propTypes = {
  post: PropTypes.object
};
